import { reportRecipientsApi, type HeadquartersContact } from './api';

/** A busca de contato do HQ: espera a pessoa parar de digitar e consulta uma vez por pausa, não por tecla. */
export class ContactSearch {
  private static readonly DELAY_MS = 250;
  private static readonly MIN_LENGTH = 2;

  term = $state('');
  results = $state<HeadquartersContact[]>([]);

  constructor(private readonly onError: (err: unknown) => void) {}

  get isSearching(): boolean {
    return this.term.trim().length >= ContactSearch.MIN_LENGTH;
  }

  /** Liga a busca ao campo; chamar na inicialização do componente. */
  watch(): void {
    $effect(() => {
      const term = this.term.trim();
      if (term.length < ContactSearch.MIN_LENGTH) {
        this.results = [];
        return;
      }
      const timer = setTimeout(() => void this.search(term), ContactSearch.DELAY_MS);
      return () => clearTimeout(timer);
    });
  }

  private async search(term: string): Promise<void> {
    try {
      this.results = await reportRecipientsApi.contacts(term);
    } catch (err) {
      this.onError(err);
    }
  }
}
